import React from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Badge } from "@/components/ui/badge";
import { Calendar } from "lucide-react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { parseLocalDate } from "@/lib/utils";

interface EventChallengesBadgeProps {
  eventId: string | null;
  className?: string;
}

const EventChallengesBadge: React.FC<EventChallengesBadgeProps> = ({ 
  eventId, 
  className = "" 
}) => {
  const { data: event } = useQuery({
    queryKey: ["event-badge", eventId],
    enabled: !!eventId,
    staleTime: 60000,
    queryFn: async () => {
      if (!eventId) return null;
      
      const { data, error } = await supabase
        .from("events")
        .select("id, name, event_date, slug")
        .eq("id", eventId)
        .maybeSingle();

      if (error || !data) return null;
      return data;
    },
  });

  if (!event) return null;

  const eventDate = parseLocalDate(event.event_date);
  const formattedDate = format(eventDate, "MMM yyyy");

  return (
    <Link to={`/events/${event.slug}`} className={className}>
      <Badge 
        variant="outline" 
        className="gap-1 text-xs hover:bg-primary/10 hover:border-primary/50 transition-colors cursor-pointer"
      >
        <Calendar className="h-3 w-3" />
        {formattedDate} Event
      </Badge>
    </Link>
  );
};

export default EventChallengesBadge;
